import { visibleSegments, WINDOW_SECONDS } from './importTimeline.js';

export default function drawTimeline(ctx, timeline, position, width, gain) {
  const height = timeline.leads.length * 180 + 65;
  const left = 60;
  const plotWidth = width - left - 12;
  const xAt = (seconds) => left + ((seconds - position) * plotWidth) / WINDOW_SECONDS;
  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, width, height);
  ctx.font = '12px sans-serif';
  for (let tenth = 0; tenth <= 100; tenth += 1) {
    const x = left + (tenth / 100) * plotWidth;
    ctx.strokeStyle = tenth % 10 === 0 ? '#e8b5be' : '#f6e3e7';
    ctx.beginPath();
    ctx.moveTo(x, 25);
    ctx.lineTo(x, height - 30);
    ctx.stroke();
    if (tenth % 20 === 0) {
      ctx.fillStyle = '#333';
      ctx.fillText(`${(position + tenth / 10).toFixed(1)}s`, Math.min(x, width - 42), height - 8);
    }
  }
  const visible = visibleSegments(timeline, position);
  timeline.leads.forEach((definition, leadIndex) => {
    const top = 25 + leadIndex * 180;
    const center = top + 90;
    ctx.save();
    ctx.beginPath();
    ctx.rect(left, top, plotWidth, 180);
    ctx.clip();
    for (let n = -8; n <= 8; n += 1) {
      ctx.strokeStyle = n % 5 === 0 ? '#e8b5be' : '#f6e3e7';
      ctx.beginPath();
      ctx.moveTo(left, center + n * 10);
      ctx.lineTo(width, center + n * 10);
      ctx.stroke();
    }
    for (const segment of visible) {
      const { recording } = segment;
      const lead = recording.leads.find((entry) => `${entry.id}:${entry.name}` === definition.key);
      if (!lead) continue; // A missing lead is blank, never interpolated.
      const leadStart = segment.start + (lead.startSample - 1) / recording.sampleRate;
      const first = Math.max(0, Math.floor((position - leadStart) * recording.sampleRate));
      const last = Math.min(
        lead.samples.length,
        Math.ceil((position + WINDOW_SECONDS - leadStart) * recording.sampleRate)
      );
      ctx.strokeStyle = '#155e55';
      ctx.lineWidth = 1.2;
      ctx.beginPath();
      for (let i = first; i < last; i += 1) {
        const x = xAt(leadStart + i / recording.sampleRate);
        const y = center - lead.samples[i] * recording.millivoltsPerUnit * 50 * gain;
        if (i === first) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
      }
      ctx.stroke(); // New path per file: no artificial line across a boundary.
    }
    ctx.restore();
    ctx.fillStyle = '#222';
    ctx.fillText(definition.name, 6, center);
  });
  visible
    .filter((segment) => segment.start > position)
    .forEach((segment) => {
      const x = xAt(segment.start);
      ctx.strokeStyle = '#536da1';
      ctx.lineWidth = 1;
      ctx.setLineDash([4, 4]);
      ctx.beginPath();
      ctx.moveTo(x, 25);
      ctx.lineTo(x, height - 30);
      ctx.stroke();
      ctx.setLineDash([]);
      ctx.fillStyle = '#304c80';
      const jump =
        segment.gap === null
          ? 'time unknown'
          : Math.abs(segment.gap) < 0.02
            ? 'contiguous'
            : segment.gap > 0
              ? `${segment.gap.toFixed(2)}s gap`
              : `${Math.abs(segment.gap).toFixed(2)}s overlap`;
      ctx.fillText(`File boundary · ${jump}`, Math.min(x + 4, Math.max(left, width - 220)), 16);
    });
}
